import zIndex from "@mui/material/styles/zIndex";

export const CMS_NAVBAR = [
  { label: "Permissions", application: "auth", link: "/cms/permission" },
  // {label:'Exam', application:'exam',link:'/cms/exam'},
  { label: "Webinar", application: "webinar", link: "/cms/webinar" },
  { label: "Newsletter", application: "", link: "/cms/newsletter" },
  { label: "Product", application: "", link: "/cms/products" },
  {
    label: "Article Webinar SPG Mapping",
    application: "spgentitymapping",
    link: "/cms/article-webinar-mapping",
  },
  {
    label: "Coaching",
    application: "",
    link: "/cms/coaching",
    application: "cnextcoachingmaster",
  },
  {
    label: "Country",
    application: "",
    link: "/cms/country",
    application: "countrydata",
  },
  {
    label: "DomainBlock",
    application: "",
    link: "/cms/domain",
    application: "user",
  },
  {
    label: "User Contact Push",
    application: "logentry",
    link: "/cms/user-contact-push",
    // application: "user",
  },
  { label: "Manage Ranking", application: "", link: "/cms/manage-ranking" },
  // { label: "Colleges", application: "", link: "/cms/colleges/manage-ranking" }
  // {label:'Institute Data', application:'',link:'/cms/'},
  // {label:'Manage product-Mapping', application:'',link:'/cms/'},
  // {label:'Articles/News', application:'',link:'/cms/'},
  // {label:'Analytics', application:'',link:'/cms/'},
  // {label:'SEO', application:'',link:'/cms/'},
  // {label:'Admission Budy', application:'',link:'/cms/'},
  // {label:'School Data', application:'',link:'/cms/'},
  { label: "Degree Grouping", application: "", link: "/cms/degree-grouping" },
  { label: "Registration", application: "registration", link: "/cms/register" },
  { label: "Hiring", application: "", link: "/cms/hiring" },
  { label: "Video", application: "", link: "/cms/video" },
  { label: "Website Settings", application: "base", link: "/cms/static-pages" },
  { label: "Tools", application: "college_predictor", link: "/cms/tools" },
  { label: "Author Profile", application: "", link: "/cms/author" },
  { label: "Content", application: "", link: "/cms/content" },
  { label: "Manage RP", application: "", link: "/cms/manage-rp" },
  { label: "Manage FAQs", application: "", link: "/cms/faqs" },
  { label: "Poll Management", application: "", link: "/cms/polls" },
  { label: "WA URL Mapping", application: "users", link: "/cms/whatsapp-mapping" },
];

export const STEPPER_LIST = [
  {
    title: "Overview",
    route: "",
  },
  {
    title: "Basic Information",
    route: "basic-details",
  },
  {
    title: "Dates & Application",
    route: "dates-application",
  },
  {
    title: "Exam Syllabuss",
    route: "exam-syllabus",
  },
  {
    title: "Exam Insights",
    route: "exam-insights",
  },
  {
    title: "Counselling Details",
    route: "counselling-details",
  },
  {
    title: "Other Details",
    route: "other-details",
  },
  {
    title: "FAQs",
    route: "exam-faqs",
  },
];

export const STEPPER_LIST_COLLEGE = [
  {
    title: "Overview",
    route: "overview",
    count: 0,
  },
  {
    title: "Basic Detail",
    route: "basic-details",
    count: 1,
  },
  {
    title: "Gallery",
    route: "gallery",
    count: 2,
  },
  {
    title: "Approvals",
    route: "approvals",
    count: 3,
  },
  {
    title: "Admission Details",
    route: "admission-details",
    count: 4,
  },
  {
    title: "Notable Alumni",
    route: "notable-alumni",
    count: 5,
  },
  {
    title: "FAQs",
    route: "faqs",
    count: 6,
  },
];

export const STEPPER_LIST_PROGRAMMES = [
  {
    title: "Basic Details",
    route: "basic-details",
  },
  {
    title: "AICTE Placements",
    route: "aicte-placements",
  },
  {
    title: "Course Overview",
    route: "overview",
  },
  {
    title: "Course Content",
    route: "content",
  },
  {
    title: "Dates and Gallery",
    route: "dates-and-gallery",
  },
];

export const PERMISSIONS_SUB_NAV = [
  {
    title: "Add Permission",
    step: 0,
    route: "",
  },
  {
    title: "Add Groups",
    step: 1,
    route: "/group",
  },
  // {
  //     title: 'Manage Group Permissions',
  //     step :2,
  //     route:'group-permission'
  // },
  {
    title: "Users Management",
    step: 3,
    route: "/userlist",
  },
  {
    title: "Block Users",
    step: 4,
    route: "/blockusers",
  },
  // {
  //   title: "Staff Register",
  //   step: 5,
  //   route: "/staff-register",
  // },
  {
    title: "Account Deletion",
    step: 4,
    route: "/user-account-deletion",
  },
  {
    title: "Active Users",
    step: 6,
    route: "/active-users",
  },

];

//Table Css
export const CUSTOM_STYLE_PERMISSION_DATA_TABLE = {
  rows: {
    style: {
      "&:nth-of-type(odd)": {
        backgroundColor: "#f1f1f1",
      },
    },
  },
  headCells: {
    style: {
      fontSize: "15px",
      fontWeight: "bold",
    },
  },
  cells: {
    style: {},
  },
  customFirstColumnCellStyle: {
    whiteSpace: "nowrap"
  },
};

// latest Table Css
export const CUSTOM_STYLE_DATA_TABLE = {
  rows: {
    style: {
        backgroundColor: "#fff",
    },
  },
  headCells: {
    style: {
      fontSize: "15px",
      color:'#8d99aa',
      // fontWeight: "bold",
    },
  },
  cells: {
    style: {},
  },
  customFirstColumnCellStyle: {
    whiteSpace: "nowrap"
  },
};

export const WEBINAR_TYPE = [
  { label: "Non Premium", value: 1 },
  { label: "Premium", value: 2 },
];

export const WEBINAR_STATUS = [
  { label: "Ongoing", value: 1 }, //live
  { label: "Scheduled", value: 2 }, // upcoming
  { label: "Ended", value: 3 }, // past
  { label: "Inactive", value: 4 },
];

export const predefinedData = [
  { id: 1, name: "Option 1" },
  { id: 2, name: "Option 2" },
  { id: 3, name: "Option 3" },
  { id: 4, name: "Option 4" },
];

export const WEBINAR_ACCESS_TYPES = [
  { label: "Open To Alls", value: 1 },
  { label: "Registered Users", value: 2 },
  { label: "Paid Users", value: 3 },
];

export const WEBINAR_URL_ACCESS_TYPES = [
  { label: "Open To All", value: 1 },
  { label: "Registered Users", value: 2 },
  { label: "Premium Paid", value: 3 },
  { label: "Premium One Free", value: 4 },
];

export const WEBINAR_URL_STATUS = [
  { label: "Active", value: 1 },
  { label: "Deactive", value: 2 },
];

export const WEBINAR_URL_CHANNEL = [
  {
    label: "Youtube",
    value: 1,
    check: "youtube",
    regex: "^(http(?:s?)://(?:www.)?youtu(?:be.com/))",
  },
  { label: "Youtube Embed", value: 3, check: "", regex: "^(http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/embed\/))" },
  {
    label: "Zoom",
    value: 2,
    check: "zoom",
    regex: "^((?:https?:)?//)?((?:www|m).)?((?:zoom.(us|in)))",
  },
];

export const NEWSLETTER_STATUS = [
  { label: "In Draft", value: 2 },
  { label: "Sent", value: 1 },
];

export const NEWSLETTER_ARTICLE_TYPE = [
  { label: "Free SEO", value: null },
  { label: "Premium SEO", value: 0 },
  { label: "Premium", value: 1 },
  { label: "Premium Paid", value: 2 },
  // { label: "News", value: "news" },
];

export const PRODUCTS_PLAN_STATUS = [
  { label: "Active", value: 1 },
  { label: "Deactive", value: 2 },
];

export const MANAGE_PLAN_ACCESS_TYPE = [
  { label: "Allow All", value: "1" },
  { label: "No Change", value: "2" },
  { label: "Block All", value: "3" },
];

export const PLAN_VALIDITY_TYPE = [
  { label: "Fixed Form Date of Purchase", value: 1 },
  { label: "Time Period", value: 2 },
];

export const PLAN_VALIDITY_YEAR = [
  { label: "2020", value: "1" },
  { label: "2021", value: "2" },
  { label: "2022", value: "3" },
  { label: "2023", value: "4" },
  { label: "2024", value: "5" },
  { label: "2025", value: "6" },
  { label: "2026", value: "7" },
  { label: "2027", value: "8" },
  { label: "2028", value: "9" },
  { label: "2029", value: "10" },
];

export const PLAN_ACCESS_TYPE = [
  { label: "Registered", value: 1 },
  { label: "Paid", value: 2 },
  { label: "Unlocked from other SPG", value: 3 },
];

export const FEATURES_STATUS = [
  { label: "Active", value: 1 },
  { label: "Deactive", value: 2 },
];

export const FEATURE_GROUPS_STATUS = [
  { label: "Active", value: 1 },
  { label: "Deactive", value: 2 },
];

export const CMS_PRODUCT_STATUS = [
  { label: "Active", value: 1 },
  { label: "Deactive", value: 2 },
];

export const LANDING_PAGE_STATUS = [
  { label: "Active", value: 1 },
  { label: "Deactive", value: 2 },
];

export const LANDING_PAGE_BANNER_STATUS = [
  { label: "Active", value: 1 },
  { label: "Deactive", value: 2 },
];

export const USER_PRODUCT_ACCESS_TYPE = [
  { label: "Active", value: 1 },
  { label: "Inactive", value: 2 },
];

export const PAYMENT_STATUS = [
  { label: "Payment Initiated", value: 1 },
  { label: "Payment Completed", value: 2 },
  { label: "Payment Failed", value: 3 },
  { label: "Payment In Process", value: 4 },
];

export const MANAGE_ACCESS_STATUS = [
  { label: "Active", value: 1 },
  { label: "No Change", value: 2 },
  { label: "Inactive", value: 3 },
];

export const FEATURE_KEYWORD = [
  { label: "MHT CET", value: "1" },
  { label: "Class 12", value: "2" },
  { label: "JEE Main", value: "3" },
  { label: "Class 11", value: "4" },
  { label: "MHT Counselling 2021", value: "5" },
  { label: "MHT CET", value: "6" },
  { label: "MHT CET", value: "7" },
  { label: "MHT CET", value: "8" },
  { label: "MHT Counselling 2021", value: "9" },
  { label: "MHT Counselling 2021", value: "10" },
  { label: "MHT Counselling 2021", value: "11" },
  { label: "MHT Counselling 2021", value: "12" },
  { label: "MHT Counselling 2021", value: "13" },
];

export const MANAGE_DIGREE_DIPLOMA = [
  {
    title: "Basic Details",
    route: "certificate",
  },
  {
    title: "AICTE Placements",
    route: "aicte-placements",
  },
];

export const MANAGE_CERTIFICATE = [
  {
    title: "Course Overview",
    route: "",
  },
  {
    title: "Course Content",
    route: "content",
  },
  {
    title: "Dates and Gallery",
    route: "dates-and-gallery",
  },
];

export const LANDING_PAGE_TYPES = [
  { label: "General", value: 1 },
  { label: "Marketing", value: 2 },
];

// export const PLAN_FEATURE_CHECK = [
//   { label: false, value: "0" },
//   { label: true, value: "1" },
// ];

export const newsletterHTMLTags = `<html>
  <head>
  <custom name="opencounter" type="tracking"> <meta charset="utf-8"></custom>
  <link href="https://fonts.googleapis.com" rel="preconnect" />
  <link crossorigin="" href="https://fonts.gstatic.com" rel="preconnect" />
  <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500&amp;display=swap" rel="stylesheet" /> 
  </head>
  <body>`;

export const MANAGE_PLAN_FRONT_END = [
  { label: "Show Title", value: "1" },
  { label: "Show Description", value: "2" },
  { label: "Show Both", value: "3" },
];

export const STEPPER_LIST_COACHING = [
  {
    title: "Overview",
    route: "overview",
  },
  {
    title: "Coaching Courses",
    route: "coaching-courses",
  },
  {
    title: "Coaching  Institute",
    route: "coaching-institute",
  },
  {
    title: "Toppers Details",
    route: "toppers-details",
  },
  {
    title: "Media",
    route: "media",
  },
];

export const SOCIAL_URL = [
  { label: "Twitter", value: "1" },
  { label: "Youtube", value: "2" },
  { label: "Facebook", value: "3" },
  { label: "Wikipedia", value: "4" },
];

export const COUNTRY_STATUS = [
  { label: "Published", value: 1 },
  { label: "Unpublished", value: 0 },
];
export const LEVEL_STATUS = [
  { label: "UG", value: "1" },
  { label: "PG", value: "2" },
  { label: "PHD", value: "3" },
];

export const COST_OF_LIVING_TYPE = [
  {
    value: 1,
    label: "House Rent",
  },
  {
    value: 2,
    label: "Food",
  },
  {
    value: 3,
    label: "Clothes & Shoes",
  },
  {
    value: 4,
    label: "Books & Stationery",
  },
  {
    value: 5,
    label: "Travel",
  },
  {
    value: 6,
    label: "Others",
  },
];

export const STEPPER_LIST_COUNTRY = [
  {
    title: "Overview",
    route: "overview",
  },
  {
    title: "Basic Detail",
    route: "basic-detail",
  },
  {
    title: "Content Detail",
    route: "content-detail",
  },
  {
    title: "Gallery",
    route: "gallery",
  },
  {
    title: "Faqs",
    route: "faqs",
  },
];

// Manage Ranking Constants

export const TABLE_DATA = [
  {
    id: 1,
    college_name: "Hydrabad University Cambridge",
    authoruty: "THE",
    ranking_type: "Overall",
    stream: "Overall",
    year: "2023",
    rank: "2",
    score: "95.5",
    rank_band: [
      { rank: "2", score: "95.2" },

    ],
  },
  {
    id: 2,
    college_name: "Hydrabad University Cambridge",
    authoruty: "THE",
    ranking_type: "Overall",
    stream: "Overall",
    year: "2023",
    rank_band: [
      { rank: "2", score: "95.2" },

    ],
  }
]

export const SEARCH_BY_COUNTRY = [
  { id: 1, label: "Hyrabad University", },
  { id: 2, label: "Hyrabad University1", },
]

export const SEARCH_BY_COLLEGE = [
  { id: 1, label: "Sample College", },
  { id: 2, label: "Sample College1", },
]

export const SEARCH_BY_AUTHORITY = [
  { id: 1, label: "The", },
]

export const SEARCH_BY_RANKING_TYPE = [
  { id: 1, label: "Overall", },
]

export const SEARCH_BY_STREAM = [
  { id: 1, label: "Sample Stream", },
  { id: 2, label: "Sample Stream1", },
]

export const SEARCH_BY_YEAR = [
  { id: 1, label: "2021", },
  { id: 2, label: "2023", },
]
// degreeGrouping constant started

export const ALL_GROUP_LIST = [
  {
    "id": 1,
    "added_on": "2023-09-20T11:31:03Z",
    "updated_on": "2023-09-20T11:31:03Z",
    "name": "first",
    "status": 0
  },
  {
    "id": 2,
    "added_on": "2023-09-20T11:31:37Z",
    "updated_on": "2023-09-20T11:31:37Z",
    "name": "2nd",
    "status": 1
  },
  {
    "id": 3,
    "added_on": "2023-09-20T11:32:13Z",
    "updated_on": "2023-09-20T11:32:13Z",
    "name": "3rd",
    "status": 1
  },
]
export const ALL_DEGREE_LIST = [
  {
    "id": 1,
    "degree_id": 1,
    "degree_name": "Diploma",
    "degree_full_name": null,
    "degree_level": "Diploma",
    "degree_status": "published",
    "group_id": 1,
    "group_name": "first",
    "group_status": 0,
    "created": "2023-09-20T11:31:07Z",
    "updated": "2023-09-20T11:31:07Z"
  },
  {
    "id": 2,
    "degree_id": 11,
    "degree_name": "Dual Degree",
    "degree_full_name": null,
    "degree_level": "UG",
    "degree_status": "published",
    "group_id": 1,
    "group_name": "first",
    "group_status": 0,
    "created": "2023-09-20T11:31:08Z",
    "updated": "2023-09-20T11:31:08Z"
  }
]

export const GROUP_LIST = [
  {
    "id": 1,
    "group_name": "first",
    "group_status": 0
  },
  {
    "id": 2,
    "group_name": "2nd",
    "group_status": 1
  },
  {
    "id": 3,
    "group_name": "3rd",
    "group_status": 1
  }
]

export const DEGREE_LIST = [
  {
    "id": 1,
    "degree_name": "Diploma",
    "degree_full_name": null
  },
  {
    "id": 11,
    "degree_name": "Dual Degree",
    "degree_full_name": null
  },
  {
    "id": 111,
    "degree_name": "M.H.M.",
    "degree_full_name": "Master of Hotel Management"
  },
  {
    "id": 2,
    "degree_name": "B.E /B.Tech",
    "degree_full_name": "Bachelor of Engineering, Bachelor of Technology"
  },
  {
    "id": 22,
    "degree_name": "P.G.D",
    "degree_full_name": "Post Graduate Diploma"
  },
]

export const GROUP_STATUS = [
  {
    "id": 0,
    "value": "Unpublished"
  },
  {
    "id": 1,
    "value": "Published"
  }
]

export const DEGREE_STATUS = [
  {
    "id": 1,
    "value": "Published"
  },
  {
    "id": 0,
    "value": "Unpublished"
  }
]

export const GROUPING_CONTEXT_LIST = [
  {
    "id": 1,
    "degree_id": 1,
    "degree_name": "Diploma",
    "degree_full_name": null,
    "degree_level": "Diploma",
    "degree_status": "published",
    "group_id": 1,
    "group_name": "first",
    "group_status": 0,
    "created": "2023-09-20T11:31:07Z",
    "updated": "2023-09-20T11:31:07Z"
  },
  {
    "id": 2,
    "degree_id": 11,
    "degree_name": "Dual Degree",
    "degree_full_name": null,
    "degree_level": "UG",
    "degree_status": "published",
    "group_id": 1,
    "group_name": "first",
    "group_status": 0,
    "created": "2023-09-20T11:31:08Z",
    "updated": "2023-09-20T11:31:08Z"
  }
]

// degreeGrouping constant ended

// Manage Messagin

export const REGISTER_SUB_NAV = [
  {
    title: "Dgree Grouping",
    step: 0,
    route: "",
  },
  {
    title: "Manage Messaging",
    step: 1,
    route: "/messaging",
  },
]
export const MANAGE_MESSEGINGDATA = {
  "form_type": [
    { id: 1, type: "Registration" },
    { id: 2, type: "Embedded Form" },
    { id: 3, type: "Add Buddy" }
  ],
  "entity_type": [
    { id: 1, type: "Article" },
    { id: 2, type: "Ebook" },
    { id: 3, type: "Exam" }
  ],
  "cta": [
    { id: 1, type: "Question_Answer" },
    { id: 2, type: "Question_Answer_Later" },
    { id: 3, type: "Question_Report" },
    { id: 4, type: "Question_Report1" },
    { id: 5, type: "Question_Report2" },

  ],
  "domain": [
    { name: "www.careers360.com" },
    { name: "studyabroad.careers360.com" },
    { name: "news.careers360.com" },
  ],
  "url_meta_pattern": [
    { label: "ebook/<ebook_id>" },
    { label: "article/<article_id>" },
    { label: "college/<college_id>" }
  ],
  "url_Type": [
    { id: 1, value: "Start With" },
    { id: 2, value: "End With" },
    { id: 3, value: "Contains" },
  ],
  "table_data": [
    {
      id: 1,
      entity_type_name: "sample entity 1",
      cta_name: "sample CTA 1",
      sub_type: "sample subType 1",
      domain_name: "sample Domain 1",
      url: " sample url 1",
      url_meta_pattern: "sample url_meta_pattern1"
    },
    {
      id: 2,
      entity_type_name: "sample entity 2",
      cta_name: "sample CTA 2",
      sub_type: "sample subType 2",
      domain_name: "sample Domain 2",
      url: " sample url 2",
      url_meta_pattern: "sample url_meta_pattern2"
    }, {
      id: 3,
      entity_type_name: "sample entity 3",
      cta_name: "sample CTA 3",
      sub_type: "sample subType 3",
      domain_name: "sample Domain 3",
      url: " sample url 3",
      url_meta_pattern: "sample url_meta_pattern 3"
    }
  ]
}

export const JOB_LOCATION_TYPES = [
  { label: "On Site", value: "1" },
  { label: "Remote", value: "2" },
  { label: "Hybrid", value: "3" },
];

export const JOB_TYPE_LIST = [
  { label: "Full Time", value: "1" },
  { label: "Part Time", value: "2" },
  { label: "Contract", value: "3" },
  { label: "Internship", value: "4" },
];

export const JOB_STATUS = [
  { label: "Active", value: "1" },
  { label: "Closed", value: "0" },
];
export const MAPPED_ENTITY_TYPE = [
  {
    "id": 1,
    "name": "College Predictor"
  },
  {
    "id": 2,
    "name": "Campaign"
  },
  {
    "id": 3,
    "name": "Learn"
  }
]

export const OFFERING_TYPE = [
  {
    "id": 1,
    "name": "Single"
  },
  {
    "id": 2,
    "name": "Multiple"
  },
]

export const LEVEL_TYPE = [
  {
    "id": 1,
    "name": "Preferred Level"
  },
  {
    "id": 2,
    "name": "Current Level"
  },
  {
    "id": 0,
    "name": "All"
  },
]
export const AUTHOR_STATUS = [
  { label: "Published", value: 1 },
  { label: "Unpublished", value: 0 },
];

export const VIDEO_STATUS = [
  { label: "Published", value: 1 },
  { label: "Unpublished", value: 0 },
];

export const VIDEO_TYPE = [
  { label: "General", value: 1 },
  { label: "Shorts", value: 2 },
];
export const AUTHOR_ENTITY_TYPE = [
  { label: "Article", value: 1, entity_type: "articles" },
  { label: "News", value: 2, entity_type: "news_domain" },
];
export const DEVICE_TYPES = [
  { label: "Web", value: 1 },
  { label: "Mobile", value: 2 },
  { label: "Android", value: 3 },
  { label: "Ios", value: 4 },
];
export const EMAIL_TYPES = [
  { label: "JohnDoe@gmail.com", value: 1 },
  { label: "JaneSmith@outlook.com", value: 2 },
  { label: "MikeBrown@yahoo.com", value: 3 },
  { label: "EmilyClark@company.com", value: 4 },
];

export const inputFlowType = {
  "result": true,
  "data": {
    "input_flow": [
      {
        "id": 1,
        "input_flow_type": "Score",
        "input_type": "Overall",
        "input_process_type": "Score"
      },
      {
        "id": 2,
        "input_flow_type": "Marks",
        "input_type": "Overall",
        "input_process_type": "Marks"
      },
      {
        "id": 3,
        "input_flow_type": "Percentile",
        "input_type": "Overall",
        "input_process_type": "Percentile"
      },
      {
        "id": 4,
        "input_flow_type": "DILR",
        "input_type": "Sectional",
        "input_process_type": "Score"
      },
      {
        "id": 5,
        "input_flow_type": "QA",
        "input_type": "Sectional",
        "input_process_type": "Score"
      },
      {
        "id": 6,
        "input_flow_type": "VA",
        "input_type": "Sectional",
        "input_process_type": "Score"
      },
      {
        "id": 7,
        "input_flow_type": "QTDI",
        "input_type": "Sectional",
        "input_process_type": "Score"
      },
      {
        "id": 8,
        "input_flow_type": "LR",
        "input_type": "Sectional",
        "input_process_type": "Score"
      },
      {
        "id": 9,
        "input_flow_type": "DA",
        "input_type": "Sectional",
        "input_process_type": "Score"
      },
      {
        "id": 10,
        "input_flow_type": "GA",
        "input_type": "Sectional",
        "input_process_type": "Score"
      },
      {
        "id": 11,
        "input_flow_type": "LC",
        "input_type": "Sectional",
        "input_process_type": "Score"
      },
      {
        "id": 13,
        "input_flow_type": "testing fdata",
        "input_type": "option1",
        "input_process_type": "option1"
      },
      {
        "id": 14,
        "input_flow_type": "sad",
        "input_type": "option1",
        "input_process_type": "option1"
      },
      {
        "id": 15,
        "input_flow_type": "asd",
        "input_type": "option1",
        "input_process_type": "option1"
      },
      {
        "id": 16,
        "input_flow_type": "sad",
        "input_type": "Overall",
        "input_process_type": "Score"
      },
      {
        "id": 17,
        "input_flow_type": "sad",
        "input_type": "Overall",
        "input_process_type": "Marks"
      }
    ],
    "result_flow": [
      {
        "id": 12,
        "result_flow_type": "LC",
        "result_type": "Sectional",
        "result_process_type": "Percentile"
      },
      {
        "id": 22,
        "result_flow_type": "sad",
        "result_type": "Sectional",
        "result_process_type": "Score"
      },
      {
        "id": 21,
        "result_flow_type": "testing result data",
        "result_type": "option1",
        "result_process_type": "option1"
      },
      {
        "id": 20,
        "result_flow_type": "R-XYZ-2",
        "result_type": "R-ABC-2",
        "result_process_type": "R-SUV-2"
      },
      {
        "id": 19,
        "result_flow_type": "ST-PWD",
        "result_type": "Category",
        "result_process_type": "Rank"
      },
      {
        "id": 18,
        "result_flow_type": "SC-PWD",
        "result_type": "Category",
        "result_process_type": "Rank"
      },
      {
        "id": 17,
        "result_flow_type": "OBC-PWD",
        "result_type": "Category",
        "result_process_type": "Rank"
      },
      {
        "id": 16,
        "result_flow_type": "ST",
        "result_type": "Category",
        "result_process_type": "Rank"
      },
      {
        "id": 15,
        "result_flow_type": "SC",
        "result_type": "Category",
        "result_process_type": "Rank"
      },
      {
        "id": 14,
        "result_flow_type": "OBC",
        "result_type": "Category",
        "result_process_type": "Rank"
      },
      {
        "id": 13,
        "result_flow_type": "GEN-PWD",
        "result_type": "Category",
        "result_process_type": "Rank"
      },
      {
        "id": 1,
        "result_flow_type": "Rank",
        "result_type": "Overall/CRL",
        "result_process_type": "Rank"
      },
      {
        "id": 11,
        "result_flow_type": "GA",
        "result_type": "Sectional",
        "result_process_type": "Percentile"
      },
      {
        "id": 10,
        "result_flow_type": "DA",
        "result_type": "Sectional",
        "result_process_type": "Percentile"
      },
      {
        "id": 9,
        "result_flow_type": "LR",
        "result_type": "Sectional",
        "result_process_type": "Percentile"
      },
      {
        "id": 8,
        "result_flow_type": "QTDI",
        "result_type": "Sectional",
        "result_process_type": "Percentile"
      },
      {
        "id": 7,
        "result_flow_type": "VA",
        "result_type": "Sectional",
        "result_process_type": "Percentile"
      },
      {
        "id": 6,
        "result_flow_type": "QA",
        "result_type": "Sectional",
        "result_process_type": "Percentile"
      },
      {
        "id": 5,
        "result_flow_type": "DILR",
        "result_type": "Sectional",
        "result_process_type": "Percentile"
      },
      {
        "id": 4,
        "result_flow_type": "Percentile",
        "result_type": "Overall",
        "result_process_type": "Percentile"
      },
      {
        "id": 3,
        "result_flow_type": "Marks",
        "result_type": "Overall",
        "result_process_type": "Marks"
      },
      {
        "id": 2,
        "result_flow_type": "Score",
        "result_type": "Overall",
        "result_process_type": "Score"
      }
    ]
  }
}
export const CHECK_PERMISSION = {
  content_seo_application: "edit_predictor_content_seo_cnext_manage_tools",
  content_seo_action: "Edit Predictor Content SEO",
  master_application: "manage_predictor_tools_cnext_manage_tools",
  master_action: "Manage Predictor Tools",
}
export const CONSUMPTION_TYPE = [
  { id: "paid", value: "Paid" },
  { id: "free", value: "Free" }
]
export const PUBLISHED_STATUS_WEB_WAP = [
  { id: "published", value: "Published" },
  { id: "unpublished", value: "Unpublished" }
]
export const PUBLISHED_STATUS_APP = [
  { id: "published", value: "Published" },
  { id: "unpublished", value: "Unpublished" }
]

export const DEFAULT_SMART_REGISTRATION_FLOW = [
  {
    "id": 1,
    "name": "Studying In",
    "peak_season": false,
    "non_peak_season": false
  },
  {
    "id": 2,
    "name": "Course Interest for College",
    "peak_season": false,
    "non_peak_season": false
  },
  {
    "id": 3,
    "name": "College Education Stream",
    "peak_season": false,
    "non_peak_season": false
  },
  {
    "id": 4,
    "name": "Passing Year",
    "peak_season": false,
    "non_peak_season": false
  },
  {
    "id": 5,
    "name": "College Admission Target Year",
    "peak_season": false,
    "non_peak_season": false
  }
];
export const FAQ_FILTERS_DATA = {
  article_filters: {
    article_title: [
      { label: "Technology", value: 1 },
      { label: "Education", value: 2 },
      { label: "Health", value: 3 },
      { label: "Business", value: 4 },
      { label: "Entertainment", value: 5 },
    ],
    article_main_categories: [
      { label: "Article", value: 1 },
      { label: "News", value: 2 },
      { label: "Guides", value: 3 },
      { label: "Tutorials", value: 4 },
      { label: "Interviews", value: 5 },
    ],
    article_sub_categories: [
      { label: "Technology", value: 1 },
      { label: "Education", value: 2 },
      { label: "Health", value: 3 },
      { label: "Business", value: 4 },
      { label: "Entertainment", value: 5 },
    ],
  },
  faq_filters: {
    faq_main_categories: [
      { label: "General", value: 1 },
      { label: "Account", value: 2 },
      { label: "Billing", value: 3 },
      { label: "Technical Support", value: 4 },
      { label: "Sales", value: 5 },
    ],
    faq_sub_categories: [
      { label: "Login Issues", value: 1 },
      { label: "Subscription Plans", value: 2 },
      { label: "Payment Methods", value: 3 },
      { label: "Troubleshooting", value: 4 },
      { label: "Product Details", value: 5 },
    ],
  },
};
export const FAQ_LIST_DATA = {
  "result": true,
  "data": {
    "lastPage": 150,
    "itemsOnPage": "20",
    "current": 1,
    "next": "http://backend-service.careers360.de/api/1/cms/article-list?page=2&page_size=20&type=articles",
    "previous": null,
    "totalRows": 2992,
    "results": [
      {
        "id": 2992,
        "title": "this is to test the pdf task new task",
        "author": "superadmin",
        "article_main_category": [
          {
            "id": 58634,
            "keyword": "Exam Preparation"
          }
        ],
        "article_sub_category": [
          {
            "id": 58650,
            "keyword": "Counselling"
          }
        ],
        "created": "2024-12-04T05:48:16Z",
        "updated": "2024-12-04T05:48:16Z"
      },
      {
        "id": 1387,
        "title": "5 Exciting Ways to Kickstart Your Start-up Journey in College!",
        "author": "aditi.narendra",
        "article_main_category": [
          {
            "id": 58638,
            "keyword": "Career Counselling"
          }
        ],
        "article_sub_category": [
          {
            "id": 58700,
            "keyword": "Career Guidance"
          }
        ],
        "created": "2024-07-10T13:13:25Z",
        "updated": "2024-09-30T12:52:54Z"
      },
      {
        "id": 2029,
        "title": "Data Preprocessing in Machine Learning: A Comprehensive Guide",
        "author": "aditi.narendra",
        "article_main_category": [
          {
            "id": 58643,
            "keyword": "Study Resources"
          }
        ],
        "article_sub_category": [
          {
            "id": 58684,
            "keyword": "Study Guides"
          }
        ],
        "created": "2024-07-10T15:58:29Z",
        "updated": "2024-09-30T08:59:46Z"
      },
      {
        "id": 2030,
        "title": "Memory Retention: Tips On Improving Recall And Scoring Well",
        "author": "aditi.narendra",
        "article_main_category": [
          {
            "id": 58643,
            "keyword": "Study Resources"
          }
        ],
        "article_sub_category": [
          {
            "id": 58684,
            "keyword": "Study Guides"
          }
        ],
        "created": "2024-07-10T15:58:44Z",
        "updated": "2024-09-30T08:57:58Z"
      },
      {
        "id": 2039,
        "title": "Money Management: Maths Concepts That Can Help You Manage Your Finances",
        "author": "aditi.narendra",
        "article_main_category": [
          {
            "id": 58643,
            "keyword": "Study Resources"
          }
        ],
        "article_sub_category": [
          {
            "id": 58722,
            "keyword": "Math Mania"
          }
        ],
        "created": "2024-07-10T16:01:26Z",
        "updated": "2024-09-30T07:28:47Z"
      }
    ]
  }
}
export const RP_FORM_MANDATORY_STATUS = [
  { label: "Mandatory", value: 1 },
  { label: "Non-Mandatory", value: 0 },
];
export const RP_FORM_STATUS = [
  { label: "Active", value: 1 },
  { label: "Inactive", value:0 },
];
export const REGENERATE_QUES_ANS = [
  { label: "Regenerate Question", value: 1 ,name:"questions"},
  { label: "Regenerate Answer", value: 2,name:"answers" },
]
export const FILTER_MODERATION_STATUS = [
  { name: "Approved", id: 2 },
  { name: "Pending", id: 1 },
  { name: "Rejected", id: 3 },
]
export const FILTER_QUESTION_MODERATION_STATUS = [
  { name: "Pending", faq_stage_id: 1 },
  { name: "Approved", faq_stage_id: 2 },
  { name: "Rejected", faq_stage_id: 3 },
]
export const FAQ_MAP_ARTICLE = [
  { label: "None", value: 1 },
  { label: "Article H2 - 2", value: 2 },
  { label: "Article H2 - 3", value: 3 },
  { label: "Article H2 - 4", value: 4 },
  { label: "Article H2 - 5", value: 5 },
]

export const FAQ_ANSWER_MODIFICATION = [
  { label: "Regenerate", value: 1, processType: "regenerate-faq" },
  { label: "Shorten", value: 2, processType: "shorten-faq" },
  { label: "Bullet Points", value: 3, processType: "convert-to-bullet-points" },
  { label: "Expand", value: 4, processType: "expand-faq" },
  { label: "Undo", value: 5, processType: "undo-faq" },
]
export const FAQ_DROPDOWNS_STYLE = {
  control: (base) => ({
    ...base,
    borderRadius: "0px",
    boxShadow: "none",
    border: "none",
    outline: "none",
    borderBottom: "1px solid #111",
    background: "transparent",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#000",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    display: "none",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  menu: (base) => ({
    ...base,
    maxHeight: "188px",
    zIndex: "999 !important",
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "188px",
    padding: 0,
  }),
};

export const FAQ_DROPDOWNS = {
    menu: (base) => ({
      ...base,
      zIndex: 999,
      maxHeight: '200px',

    }),
    menuList: (base) => ({
      ...base,
      zIndex: 999,
      maxHeight: '200px',

    }),
  }

export const DROPDOWNS_STYLE = {
  control: (base) => ({
    ...base,
    width: window.innerWidth <= 1280 ? "280px" : "330px", // responsive
    borderRadius: "8px",
    textAlign: "center",
    fontWeight: "600",
    marginRight: "8px",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  menu: (base) => ({
    ...base,
    width: window.innerWidth <= 1280 ? "280px" : "330px", // responsive
    textAlign: "center",
    zIndex:'999'
  }),

};
export const FAQ_BUTTONS_STYLE = {
  control: (base) => ({
    ...base,
    borderRadius: "6px",
    boxShadow: "none",
    border: "none",
    outline: "none",
    background: "#524492",
    textAlign: "center",
    fontWeight: "600",
    minWidth: "200px",
    fontSize:window.innerWidth <= 1280 ? "12px" : "14px", // responsive
  }),
  placeholder: (base) => ({
    ...base,
    color: "#fff",
    fontSize:window.innerWidth <= 1280 ? "12px" : "14px", // responsive
  }),
  dropdownIndicator: (base) => ({
    ...base,
    display: "none",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  menu: (base) => ({
    ...base,
    maxHeight: "220px",
    zIndex: "999 !important"
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "220px",
    padding: 0,
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
    fontWeight: "700",
    textAlign: "center",
    fontSize:window.innerWidth <= 1280 ? "12px" : "14px", // responsive
  }),
  option: (base, { isSelected }) => ({
    ...base,
    background: isSelected ? "#524492" : "transparent",
    color: isSelected ? "#fff" : "#524492",
    ":hover": {
      background: "#DAD9D9",
      color: "#524492",
    },
    textAlign: "center"
  }),

};
export const FAQ_ENTITY_TYPE = [
  { label: "Article", value: 1 },
  { label: "College", value: 2 },
  { label: "College Ranking", value: 3 },
  { label: "Exam", value: 4 },
]
export const FAQ_KEYWORDS = [
  { label: "Tag 1", value: 1 },
  { label: "Tag 2", value: 2 },
  { label: "Tag 3", value: 3 },
  { label: "Tag 4", value: 4 },
  { label: "Tag 5", value: 5 },
  { label: "Tag 6", value: 6 },
  { label: "Tag 7", value: 7 },
  { label: "Tag 8", value: 8 },
  { label: "Tag 9", value: 9 },
  { label: "Tag 10", value: 10 },
]

export const FAQ_H1_GENERATION = [
  {
    "h2": "H2 Title 1",
    "questions": [
      {
        "question": "What is HTML?",
        "story": "<p>HTML stands for HyperText Markup Language. It is used to structure web pages.</p>",
        "weightage": 5
      },
      {
        "question": "What is a semantic tag in HTML?",
        "story": "<p>Semantic tags clearly define the meaning of the content, like <article>, <section>, and <header>.</p>",
        "weightage": 3
      },
      {
        "question": "What are HTML attributes?",
        "story": "<p>HTML attributes provide additional information about an element, like 'src' in <img>.</p>",
        "weightage": 4
      }
    ]
  },
  {
    "h2": "H2 Title 2",
    "questions": [
      {
        "question": "What is CSS?",
        "story": "<p>CSS stands for Cascading Style Sheets. It is used to style the layout of web pages.</p>",
        "weightage": 4
      },
      {
        "question": "What is Flexbox?",
        "story": "<p>Flexbox is a layout model that allows items to align and distribute space within a container.</p>",
        "weightage": 5
      },
      {
        "question": "What are CSS Selectors?",
        "story": "<p>CSS selectors define the elements to which CSS rules apply, like '.class' or '#id'.</p>",
        "weightage": 4
      }
    ]
  },
  {
    "h2": "H2 Title 3",
    "questions": [
      {
        "question": "What is JavaScript?",
        "story": "<p>JavaScript is a programming language that enables interactivity on web pages.</p>",
        "weightage": 5
      },
      {
        "question": "What is the DOM?",
        "story": "<p>DOM stands for Document Object Model, representing the page's structure as objects.</p>",
        "weightage": 4
      },
      {
        "question": "What is an Event Listener?",
        "story": "<p>An Event Listener waits for user interactions like clicks or key presses to trigger specific actions.</p>",
        "weightage": 4
      }
    ]
  },
  {
    "h2": "H2 Title 4",
    "questions": [
      {
        "question": "What is React?",
        "story": "<p>React is a JavaScript library for building user interfaces, maintained by Facebook.</p>",
        "weightage": 5
      },
      {
        "question": "What is a React component?",
        "story": "<p>A React component is a reusable, independent piece of UI, defined as a function or class.</p>",
        "weightage": 4
      },
      {
        "question": "What is JSX?",
        "story": "<p>JSX stands for JavaScript XML, allowing you to write HTML within JavaScript.</p>",
        "weightage": 4
      }
    ]
  },
  {
    "h2": "H2 Title 5",
    "questions": [
      {
        "question": "What is an API?",
        "story": "<p>API stands for Application Programming Interface, allowing software systems to communicate.</p>",
        "weightage": 4
      },
      {
        "question": "What is RESTful API?",
        "story": "<p>A RESTful API uses HTTP requests to perform CRUD operations on resources.</p>",
        "weightage": 5
      },
      {
        "question": "What is JSON?",
        "story": "<p>JSON stands for JavaScript Object Notation, used for storing and exchanging data.</p>",
        "weightage": 4
      }
    ]
  },
  {
    "h2": "H2 Title 6",
    "questions": [
      {
        "question": "What is Git?",
        "story": "<p>Git is a version control system used to track changes in code during development.</p>",
        "weightage": 5
      },
      {
        "question": "What is a Git repository?",
        "story": "<p>A Git repository is a storage location for your codebase, enabling version control and collaboration.</p>",
        "weightage": 4
      },
      {
        "question": "What is branching in Git?",
        "story": "<p>Branching allows you to work on different versions of a codebase simultaneously.</p>",
        "weightage": 5
      }
    ]
  },
  {
    "h2": "H2 Title 7",
    "questions": [
      {
        "question": "What is Web Hosting?",
        "story": "<p>Web hosting allows websites to be published online, making them accessible via the internet.</p>",
        "weightage": 4
      },
      {
        "question": "What is a Domain Name?",
        "story": "<p>A domain name is the web address users type into a browser to access a website.</p>",
        "weightage": 3
      },
      {
        "question": "What is DNS?",
        "story": "<p>DNS stands for Domain Name System, translating domain names into IP addresses.</p>",
        "weightage": 4
      }
    ]
  }
];

export const H2_CHECKBOX_DATA = [
  { value: 1, label: "About IIT Delhi", isNew: true },
  { value: 2, label: "About Delhi Highlights", isNew: false },
  { value: 3, label: "IIT Delhi Facilities", isNew: true },
  { value: 4, label: "IIT Delhi Research", isNew: false },
  { value: 5, label: "IIT Delhi Admissions", isNew: true },
  { value: 6, label: "IIT Delhi Campus", isNew: false },
  { value: 7, label: "IIT Delhi Alumni", isNew: true },
  { value: 8, label: "IIT Delhi Departments", isNew: false },
  { value: 9, label: "IIT Delhi Departments", isNew: false },
  { value: 10, label: "IIT Delhi Departments", isNew: false },

];

export const H2_QUESTION_GEBERATION = [
  {
    value: 1,
    label: "About IIT Delhi",
    generate_questions: [
      { ques_id: 1, text: "What is the established year of IIT Delhi?", moderationStatus: "Pending" },
      { ques_id: 2, text: "How old is IIT Delhi?", moderationStatus: "Pending" },
      { ques_id: 3, text: "What are the achievements of IIT Delhi?", moderationStatus: "Pending" },
      { ques_id: 4, text: "What is the history of IIT Delhi?", moderationStatus: "Pending" },
      { ques_id: 5, text: "Why is IIT Delhi renowned globally?", moderationStatus: "Pending" },
    ],
  },
  {
    value: 2,
    label: "About Delhi Highlights",
    generate_questions: [
      { ques_id: 1, text: "What are the main highlights of Delhi?", moderationStatus: "Pending" },
      { ques_id: 2, text: "Why is Delhi famous?", moderationStatus: "Pending" },
      { ques_id: 3, text: "What are the must-visit places in Delhi?", moderationStatus: "Pending" },
      { ques_id: 4, text: "What is the cultural significance of Delhi?", moderationStatus: "Pending" },
      { ques_id: 5, text: "What is the history of Delhi?", moderationStatus: "Pending" },
    ],
  },
  {
    value: 3,
    label: "IIT Delhi Facilities",
    generate_questions: [
      { ques_id: 1, text: "What facilities are available at IIT Delhi?", moderationStatus: "Pending" },
      { ques_id: 2, text: "Does IIT Delhi have sports facilities?", moderationStatus: "Pending" },
      { ques_id: 3, text: "What kind of accommodation is provided at IIT Delhi?", moderationStatus: "Pending" },
      { ques_id: 4, text: "Are there recreational facilities at IIT Delhi?", moderationStatus: "Pending" },
      { ques_id: 5, text: "What technological facilities are offered by IIT Delhi?", moderationStatus: "Pending" },
    ],
  },
  {
    value: 4,
    label: "IIT Delhi Research",
    generate_questions: [
      { ques_id: 1, text: "What are the key research areas of IIT Delhi?", moderationStatus: "Pending" },
      { ques_id: 2, text: "What research facilities does IIT Delhi provide?", moderationStatus: "Pending" },
      { ques_id: 3, text: "What are the major research achievements of IIT Delhi?", moderationStatus: "Pending" },
      { ques_id: 4, text: "How does IIT Delhi support innovation?", moderationStatus: "Pending" },
      { ques_id: 5, text: "Are there any notable research projects at IIT Delhi?", moderationStatus: "Pending" },
    ],
  },
  {
    value: 5,
    label: "IIT Delhi Admissions",
    generate_questions: [
      { ques_id: 1, text: "What is the admission process for IIT Delhi?", moderationStatus: "Pending" },
      { ques_id: 2, text: "What are the eligibility criteria for IIT Delhi?", moderationStatus: "Pending" },
      { ques_id: 3, text: "What entrance exams are accepted by IIT Delhi?", moderationStatus: "Pending" },
      { ques_id: 4, text: "Does IIT Delhi have reservations or quotas?", moderationStatus: "Pending" },
      { ques_id: 5, text: "What documents are required for admission to IIT Delhi?", moderationStatus: "Pending" },
    ],
  },
  {
    value: 6,
    label: "IIT Delhi Campus",
    generate_questions: [
      { ques_id: 1, text: "What is the size of the IIT Delhi campus?", moderationStatus: "Pending" },
      { ques_id: 2, text: "What facilities are available on the IIT Delhi campus?", moderationStatus: "Pending" },
      { ques_id: 3, text: "What is the environment like at IIT Delhi?", moderationStatus: "Pending" },
      { ques_id: 4, text: "What events are held on the IIT Delhi campus?", moderationStatus: "Pending" },
      { ques_id: 5, text: "What makes the IIT Delhi campus unique?", moderationStatus: "Pending" },
    ],
  },
  {
    value: 7,
    label: "IIT Delhi Alumni",
    generate_questions: [
      { ques_id: 1, text: "Who are some famous alumni of IIT Delhi?", moderationStatus: "Pending" },
      { ques_id: 2, text: "What contributions have IIT Delhi alumni made globally?", moderationStatus: "Pending" },
      { ques_id: 3, text: "Are there any alumni networks for IIT Delhi?", moderationStatus: "Pending" },
      { ques_id: 4, text: "What initiatives have IIT Delhi alumni started?", moderationStatus: "Pending" },
      { ques_id: 5, text: "How does IIT Delhi engage with its alumni?", moderationStatus: "Pending" },
    ],
  },
  {
    value: 8,
    label: "IIT Delhi Departments",
    generate_questions: [
      { ques_id: 1, text: "What are the major departments at IIT Delhi?", moderationStatus: "Pending" },
      { ques_id: 2, text: "What courses are offered by each department at IIT Delhi?", moderationStatus: "Pending" },
      { ques_id: 3, text: "Who are the notable faculty members in IIT Delhi's departments?", moderationStatus: "Pending" },
      { ques_id: 4, text: "What facilities are available for each department at IIT Delhi?", moderationStatus: "Pending" },
      { ques_id: 5, text: "How does IIT Delhi's department structure work?", moderationStatus: "Pending" },
    ],
  },
];

export const faqBreadcrumbs = {
  article: { path: `/cms/faqs/article-faqs/`, label: "Manage Article FAQs" },
  exam: { path: `/cms/faqs/exam-faqs/`, label: "Manage Exam FAQs" },
  collegeDetail: { path: `/cms/faqs/college-detail-faqs/`, label: "Manage College FAQs" },
  collegeRankingFacet: { path: `/cms/faqs/college-facet-ranking-faqs`, label: "Manage College Facet & Ranking FAQs" },

};




export const PAGEAVAILABILITY= [
  {
    page_type: "Articles",
    value: 1,
    show_on_page: true,
  },
  {
    page_type: "Colleges",
    value: 2,
    show_on_page: true,
  },
  {
    page_type: "Exams",
    value: 3,
    show_on_page: true,
  },
  {
    page_type: "News",
    value: 4,
    show_on_page: true,
  },
  {
    page_type: "e-Books",
    value: 5,
    show_on_page: true,
  },
  {
    page_type: "Courses",
    value: 6,
    show_on_page: true,
  },
  {
    page_type: "Career Pages",
    value: 7,
    show_on_page: true,
  },
  {
    page_type: "App",
    value: 8,
    show_on_page: true,
  },
];

export const ALLOW_ACCESS = [
  {id:1,value:'Anonymous'},
  {id:2,value:'Registered'},
]


export const DEVICE_TYPE = [
  {id: 1, value: "Web"},
  {id: 2, value: "Mobile"},
  {id: 3, value: "App"},
]

export const REASON_DROPDOWN = [
  {id: 1, value: "Spam"},
  {id: 2, value: "Irrelavent Comment"},
  {id: 3, value: "Other"},
]
